import { render, staticRenderFns } from "./AdminRoleSearch.vue?vue&type=template&id=aa97535e&"
import script from "./AdminRoleSearch.vue?vue&type=script&lang=ts&"
export * from "./AdminRoleSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports